import React from "react";
import {components} from 'react-select';
import CreatableSelect from 'react-select/creatable';
import "../../style/AutoComplete.less";
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function AutoComplete(
    {
        options,
        value,
        setValue,
        displayError,
        errorMessage,
        placeholder,
        isDisabled,
        className,
        showDeleteIcon,
        onDeleteOption
    }) {

    const [t] = useTranslation();
    const errorClasses = ' is-invalid border-danger';

    const DeleteOption = ({
                              children,
                              ...props
                          }) => {
        return (
            <components.Option {...props}>
                <div>
                    <span>{children}</span>
                    {
                        !props.data.__isNew__ &&
                        <span className="float-right">
                        <FontAwesomeIcon
                            onClick={onDeleteOption ? () => onDeleteOption(props.data.value) : null}
                            className="ml-3 icon-primary"
                            icon="trash-alt"
                            title={t('Button.DELETE')}
                            role="button"
                        />
                    </span>
                    }
                </div>
            </components.Option>
        );
    };

    let componentsToReplace = {};

    if (showDeleteIcon) {
        componentsToReplace = {
            ...componentsToReplace,
            Option: DeleteOption
        };
    }

    return (
        <div className={className ? className : "form-group"}>
            <div className={`input-group${displayError ? errorClasses : ''}`}>
                <CreatableSelect
                    isClearable
                    className={`${displayError ? 'is-invalid' : ''} ${value ? 'value-true' : ''}`}
                    placeholder={placeholder ? placeholder : t('Common.PLEASE_SELECT_INPUT')}
                    noOptionsMessage={() => t('Common.NO_OPTIONS')}
                    formatCreateLabel={(entry) => `${t('Common.CREATE')} "${entry}"`}
                    classNamePrefix="dropdown"
                    onChange={(entry) => {
                        setValue(entry?.value ?? null);
                    }}
                    value={value}
                    options={options}
                    isDisabled={isDisabled ? isDisabled : false}
                    components={componentsToReplace}
                />
            </div>
            {
                displayError &&
                <div className="invalid-feedback">
                    {errorMessage ? errorMessage : t('Validation.REQUIRED')}
                </div>
            }
        </div>
    );
}

export default AutoComplete;
